"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderReviewTagService = void 0;
class OrderReviewTagService {
    constructor(gaService) {
        this.gaService = gaService;
        this.gaService = gaService;
    }
    getStepName(step) {
        return step === 1 ? 'avaliacao' : 'motivo-pulou-avaliacao';
    }
    closeClick(step) {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'interaction_avaliacao_compra',
                cd_interaction_detail: 'click:fechar',
                cd_step: `${step}:${this.getStepName(step)}`,
            },
        });
    }
    reviewLaterClick(step) {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'interaction_avaliacao_compra',
                cd_interaction_detail: 'click:avaliar-depois',
                cd_step: `${step}:${this.getStepName(step)}`,
            },
        });
    }
    backToReviewClick(step) {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'interaction_avaliacao_compra',
                cd_interaction_detail: 'click:voltar-para-avaliacao',
                cd_step: `${step}:${this.getStepName(step)}`,
            },
        });
    }
    submitReview(step) {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'interaction_avaliacao_compra',
                cd_interaction_detail: 'click:enviar-resposta',
                cd_step: `${step}:${this.getStepName(step)}`,
            },
        });
    }
    orderCancelledClick(step) {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'interaction_avaliacao_compra',
                cd_interaction_detail: 'click:essa-compra-foi-cancelada',
                cd_step: `${step}:${this.getStepName(step)}`,
            },
        });
    }
    didNotReceivedMyOrderClick(step) {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'interaction_avaliacao_compra',
                cd_interaction_detail: 'click:ainda-nao-recebi-minha-compra',
                cd_step: `${step}:${this.getStepName(step)}`,
            },
        });
    }
    callbackOrderReviewRatingSuccess(rating) {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'callback_avaliacao_compra_sucesso',
                cd_interaction_detail: `avaliacao-nota-${rating}`,
            },
        });
    }
    callbackOrderReviewRatingError() {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'callback_avaliacao_compra_erro',
                cd_error_message: 'nao-foi-possivel-finalizar-avaliacao',
            },
        });
    }
    callbackOrderReviewCommentSuccess() {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'callback_avaliacao_compra_sucesso',
                cd_interaction_detail: 'avaliacao-comentario',
            },
        });
    }
    callbackOrderReviewCommentError() {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'callback_avaliacao_compra_erro',
                cd_error_message: 'nao-foi-possivel-finalizar-avaliacao',
            },
        });
    }
    callbackSkipSubmitSuccess(reason) {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'callback_avaliacao_compra_sucesso',
                cd_interaction_detail: `pulou-avaliacao-motivo-${reason}`,
            },
        });
    }
    callbackSkipSubmitError() {
        this.gaService.event({
            event: 'analytics-event',
            event_parameters: {
                event_name: 'callback_avaliacao_compra_erro',
                cd_error_message: 'nao-foi-possivel-finalizar-avaliacao',
            },
        });
    }
}
exports.OrderReviewTagService = OrderReviewTagService;
